import { render, staticRenderFns } from "./textTemplate.vue?vue&type=template&id=034d51da&scoped=true&"
import script from "./textTemplate.vue?vue&type=script&lang=js&"
export * from "./textTemplate.vue?vue&type=script&lang=js&"
import style0 from "./textTemplate.vue?vue&type=style&index=0&id=034d51da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d51da",
  null
  
)

export default component.exports